import { statusLabel } from "../manageLead/shared";
import {
  IST_TIMEZONE,
  STEPS,
} from "./constants";


export const pretty = (value = "") =>
  statusLabel(
    String(value).replaceAll("-", "_")
  );

export const displayStatus = (status) => {
  if (status === "converted") {
    return "Booked";
  }

  return pretty(status);
};

export const formatIST = (date) => {
  if (!date) return "—";

  const parsed = new Date(date);

  if (Number.isNaN(parsed.getTime())) {
    return "—";
  }

  return new Intl.DateTimeFormat("en-IN", {
    timeZone: IST_TIMEZONE,

    day: "2-digit",
    month: "short",
    year: "numeric",

    hour: "2-digit",
    minute: "2-digit",

    hour12: true,
  }).format(parsed);
};

export const getISTParts = (
  date = new Date()
) => {
  const parts =
    new Intl.DateTimeFormat("en-GB", {
      timeZone: IST_TIMEZONE,

      year: "numeric",
      month: "2-digit",
      day: "2-digit",

      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",

      hourCycle: "h23",
    }).formatToParts(date);

  return parts.reduce((result, item) => {
    if (item.type !== "literal") {
      result[item.type] = item.value;
    }

    return result;
  }, {});
};

export const toISTInputValue = (date) => {
  const parts = getISTParts(date);

  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
};

export const parseISTInputValue = (
  value
) => {
  if (!value) return null;

  return new Date(
    `${value}:00+05:30`
  );
};

/* -------------------------------------------------------------------------- */
/*                              RETRY SCHEDULE                                */
/* -------------------------------------------------------------------------- */

export const getNextRetryAt = (
  attempt
) => {
  const now = new Date();

  /*
    Attempt 1
    → after 3 hours
  */
  if (attempt === 1) {
    return new Date(
      now.getTime() +
        3 * 60 * 60 * 1000
    );
  }

  /*
    Attempt 2
    → next day 10 AM IST
  */
  if (attempt === 2) {
    const parts =
      getISTParts(now);

    const todayStart =
      new Date(
        `${parts.year}-${parts.month}-${parts.day}T00:00:00+05:30`
      );

    return new Date(
      todayStart.getTime() +
        24 * 60 * 60 * 1000 +
        10 * 60 * 60 * 1000
    );
  }

  /*
    Attempt 3
    → after 3 days
  */
  if (attempt === 3) {
    return new Date(
      now.getTime() +
        3 *
          24 *
          60 *
          60 *
          1000
    );
  }

  /*
    Attempt 4
    → no further retry
  */
  return null;
};

/* -------------------------------------------------------------------------- */
/*                               DEFAULT STEP                                 */
/* -------------------------------------------------------------------------- */

export const getDefaultStep = (lead) => {
  if (!lead) {
    return STEPS.PRIMARY;
  }

  /*
    Important:
    retry gets priority over L2 because
    L2 also uses the same retry process.
  */
  if (
    Number(lead.retryCount || 0) > 0
  ) {
    return STEPS.QUIET;
  }

  if (
    lead.level === "level-2" ||
    lead.currentStatus === "transferred"
  ) {
    return STEPS.L2;
  }

  if (
    lead.currentStatus === "interested"
  ) {
    return STEPS.CONTACTED;
  }

  return STEPS.PRIMARY;
};


export const getThemeColor = (variant) =>{
  let color = "bg-slate-900 text-white";

  if(variant === "hot"){
    color = "bg-red-100 text-red-600 border border-red-600";
  } else if(variant === "warm"){
    color = "bg-amber-100 text-amber-600 border border-amber-600";
  } else if(variant === "cold"){
    color = "bg-slate-100 text-slate-600 border border-slate-600";
  }

  return color;
}